import {
  ContentChannelPatchRequest,
  FileUploadScope,
  IContentChannel,
} from "../../types/NendaTypes";
import { httpClient, Service } from "./client";
import { Observable } from "rxjs";
import { AssetPlayabilityResponse } from "@shared/cmsAssetPlayability";

class ContentChannelService extends Service {
  getChannels() {
    return httpClient.get("/contentchannel", this.authHeader());
  }

  getChannel(id: string) {
    return httpClient.get(`/contentchannel/${id}`, this.authHeader());
  }

  createChannel(channel: IContentChannel) {
    return httpClient.post("/contentchannel", channel, this.authHeader());
  }

  updateChannel(request: ContentChannelPatchRequest) {
    return httpClient.patch(
      `/contentchannel/${request.data._id}`,
      request,
      this.authHeader()
    );
  }

  getAssetPlayability(
    assetIds: string[]
  ): Observable<AssetPlayabilityResponse> {
    return httpClient.post(
      "/contentchannel/asset-playability",
      { assetIds },
      this.authHeader()
    );
  }

  deleteChannel(id: string) {
    return httpClient.delete(`/contentchannel/${id}`, this.authHeader());
  }

  uploadFile(id: string, file: File, scope: FileUploadScope) {
    const formData = new FormData();
    formData.append("scope", scope);
    formData.append("file", file);
    return httpClient.put(
      `/contentchannel/${id}/file`,
      formData,
      {
        ...this.authHeader(),
      },
      false
    );
  }
}

export const contentChannelService = new ContentChannelService();
